// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectOutlinedSvg from "@ant-design/icons-svg/es/asn/MoneyCollectOutlined";
import AntdIcon from '../components/AntdIcon';

var MoneyCollectOutlined = function MoneyCollectOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectOutlinedSvg
  }));
};

MoneyCollectOutlined.displayName = 'MoneyCollectOutlined';
export default React.forwardRef(MoneyCollectOutlined);